import { createContext } from 'react';
import { LoadingContext } from './GlobalLoading.models';

export const loadingContext = createContext<LoadingContext>({
  content: undefined,
  endLoading: () => null,
  isLoading: false,
  loadingQueueRef: { current: new Set() },
  setContent: () => null,
  startLoading: () => null,
});

export const { Provider: LoadingProvider } = loadingContext;
